
import { environment } from "../../../environments/environment";


//env
export const apiUrl = environment.apiBase+'/'+environment.apiVersion;
export const xapiKey = environment.xApiToken;
export const apiVersion = environment.apiVersion;

export const ForgotPasswordLink = '/auth/forgotpassword';
export const FactorVerificationLink = '/auth/factorverification'; 


//values
export const UserType = 'admin';
export const LandingPageTitle = 'Apps';


//contents

export const HomeTitle = 'Welcome to CureSelect Healthcare';
export const HomeSubmsg = '360° Digital Care - Anytime, Anywhere, For Anyone - Accountability & Affordability';

//URLS
export const LoginLink = 'auth/login';
export const DashboardLink = environment.apiVersion+'/main';

//Pagination
export const PageSize = '10';
export const PageSizeOptions = ['10','20'];

